import React from "react";
import { Jumbotron } from "react-bootstrap";
import "./index.css";
import * as ROUTES from "../Constants/routes";

const About = () => {
  return (
    <div>
      <Jumbotron
        style={{ margin: 0, backgroundColor: "#f58c0c", borderRadius: 0 }}
      >
        <h1 id="mission">Mission</h1>
        <p>
          March 2021 marked a year of COVID-19. Which is definitely not a good
          thing. Yet it gets worse. Countries are suffering. India itself is
          experiencing jaw-dropping numbers in cases AND deaths, lacking the
          adequate oxygen, hospital beds, and medicine. For context, at the time
          of writing, India has suffered a whopping 16 million infections with
          half a million deaths. Their government has taken note of the problem,
          but not enough is being done.
          <br></br>
          That's why we launched Envato. We aim to educate the younger people in
          our society in order to generate funds for the situation in India and
          other countries.
          <br></br>
          Come join us! If you have any questions or concerns, consult the{" "}
          <a className="link" href={ROUTES.SUPPORTUS}>
            Support Us
          </a>{" "}
          page for our contact information.
        </p>
      </Jumbotron>
      <Jumbotron style={{ margin: 0, borderRadius: 0 }}>
        <h1 id="founders">Founders</h1>
        <div className="bio-container">
          <div className="bio-arnav">
            <h3>Arnav Adhikari</h3>
            <p>
              Arnav is a freshman at Bellaire High School. One day he was
              reading the news, scrolling through to find yet another topic
              addressing the extremity of India's COVID-19 statistics. Alarmed
              by the direness of the situation, he sought to do something about
              it, and upon discussion with Rutva Gupta, Envato was born.
            </p>
          </div>

          <div className="bio-rutva">
            <h3>Rutva Gupta</h3>
            <p>
              Rutva is a freshmen at Tompkins high school. Rutva's family has
              been greatly affected by the pandemic, so Envato means a lot to
              him. With Arnav, he wants to help fix the COVID-19 crisis in one
              of the most suffering countries in the world. ``I wish to be an
              avid contributor to fixing the overseas issues. Let's stand
              together to make a difference.''
            </p>
          </div>
        </div>

        <h1 id="administrators">Administrators</h1>
        <div className="bio-container">
          <div className="bio-harshith">
            <h3>Harshith Arja</h3>
            <p>
              Harshith is a freshman at Tompkins High School. He was born in
              India and has deep ties to it. He was greatly impacted by COVID-19
              as his grandmother died due to India's inefficiency. He is using
              his grandmother's death as motivation to improve as many lives as
              possible.
            </p>
          </div>

          <div className="bio-ishan">
            <h3>Ishan Arora</h3>
            <p>
              Ishan is a freshman at Carnegie Vanguard High School. He has
              a deep connection with India, and was impacted greatly by the
              COVID-19 pandemic. He hopes that through Envato he can make an
              impact and help the lives of as many people as possible. Bharat
              Mata ki Jai.
            </p>
          </div>
        </div>
      </Jumbotron>
    </div>
  );
}

export default About;
